import { render, staticRenderFns } from "./Vendeurs.vue?vue&type=template&id=91f5bb8c&scoped=true"
import script from "./Vendeurs.vue?vue&type=script&lang=js"
export * from "./Vendeurs.vue?vue&type=script&lang=js"
import style0 from "./Vendeurs.vue?vue&type=style&index=0&id=91f5bb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f5bb8c",
  null
  
)

export default component.exports